import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FaPrint, FaTag, FaDollarSign, FaTrash } from "react-icons/fa";
import {
  getFormattedPrice,
  getVendorSettings,
  getAPIURL,
  getFormattedDate,
} from "../../../services/helper";
import http from "../../../services/http";
import Swal from "sweetalert2";
import Barcode from "react-barcode";

const InvoiceModal = ({
  isOpen,
  toggle,
  selectedOrder,
  onPrintReceipt,
  onPrintLabel,
  onRefund,
  onDelete,
}) => {
  const handleRefund = async () => {
    const { value: formValues } = await Swal.fire({
      title: "Process Refund",
      html: `
        <div style="text-align: left;">
          <input id="refund-amount" class="swal2-input" type="number" placeholder="Refund amount" max="${selectedOrder.order_total}" style="margin-bottom: 10px;">
          <input id="refund-reason" class="swal2-input" type="text" placeholder="Refund reason" style="margin-bottom: 10px;">
          <small style="display: block; text-align: center;">Max refund: ${selectedOrder.order_total}</small>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Process Refund",
      preConfirm: () => {
        const amount = document.getElementById("refund-amount").value;
        const reason = document.getElementById("refund-reason").value;

        if (!amount || amount <= 0) {
          Swal.showValidationMessage("Please enter a valid amount");
          return false;
        }
        if (parseFloat(amount) > parseFloat(selectedOrder.order_total)) {
          Swal.showValidationMessage("Refund amount cannot exceed order total");
          return false;
        }
        if (!reason.trim()) {
          Swal.showValidationMessage("Please enter a refund reason");
          return false;
        }

        return { amount: parseFloat(amount), reason: reason.trim() };
      },
    });

    if (formValues) {
      try {
        const api_url = getAPIURL();
        const { data } = await http.post(`${api_url}/refund-order`, {
          order_id: selectedOrder.order_id,
          refund_amount: formValues.amount,
          refund_reason: formValues.reason,
        });
        if (data.success) {
          Swal.fire("Success!", "Refund processed successfully", "success");
          if (onRefund) onRefund();
          toggle();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to process refund", "error");
        console.error("Error processing refund:", error);
      }
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Invoice</ModalHeader>
      <ModalBody>
        {selectedOrder && (
          <div
            style={{
              fontFamily: "monospace",
              padding: "10px",
              maxWidth: "350px",
              margin: "0 auto",
              backgroundColor: "#f9f9f9",
              fontSize: "12px",
            }}
          >
            {(() => {
              const { showStoreLogo } = getVendorSettings("receiptTemplate");
              const vendor_logo = showStoreLogo
                ? `${window.location.origin}/assets/images/logo/logo.png`
                : null;

              return (
                <div style={{ textAlign: "center", margin: "10px 0" }}>
                  {vendor_logo && (
                    <img
                      src={vendor_logo}
                      alt="Store Logo"
                      style={{ maxHeight: "60px", maxWidth: "200px" }}
                    />
                  )}
                </div>
              );
            })()}
            {(() => {
              const {
                showStoreAddress,
                showStoreEmail,
                showStoreLogo,
                showStoreName,
                showStorePhone,
                headerNote,
                footerNote,
              } = getVendorSettings("receiptTemplate");

              const vendor_email = showStoreEmail
                ? getVendorSettings("email")
                : null;
              const vendor_store_name = showStoreName
                ? getVendorSettings("store_name")
                : null;
              const vendor_address = showStoreAddress
                ? getVendorSettings("vendor_contact_address")
                : null;
              const vendor_phone = showStorePhone
                ? getVendorSettings("vendor_contact_phone")
                : null;

              return (
                <div style={{ textAlign: "center", marginBottom: "5px" }}>
                  {vendor_store_name && (
                    <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                      {vendor_store_name}
                    </div>
                  )}
                  {vendor_address && (
                    <div style={{ fontSize: "11px" }}>{vendor_address}</div>
                  )}
                  {vendor_phone && (
                    <div style={{ fontSize: "11px" }}>Tel: {vendor_phone}</div>
                  )}
                  {vendor_email && (
                    <div style={{ fontSize: "11px" }}>{vendor_email}</div>
                  )}
                  {headerNote && (
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      {headerNote}
                    </div>
                  )}
                </div>
              );
            })()}
            <div style={{ marginBottom: "10px" }}>
              <div>Date: {selectedOrder.order_date}</div>
              <div>Trans: Sales Transaction</div>
              <div>Trans#: {selectedOrder.order_id}</div>
            </div>

            {/* Products Section */}
            {selectedOrder.products && (
              <div style={{ marginBottom: "10px" }}>
                {selectedOrder.products.map((product, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <div style={{ width: "70%" }}>
                      <div
                        style={{ display: "flex", gap: "8px", fontWeight: 500 }}
                      >
                        <span>{product.qty}x</span>
                        <span
                          style={{
                            flex: 1,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {product.name}
                        </span>
                      </div>
                      {product.addons && (
                        <div
                          style={{
                            marginTop: "2px",
                            paddingLeft: "20px",
                            fontSize: "0.85em",
                            color: "#777",
                          }}
                        >
                          {(() => {
                            try {
                              const addons =
                                typeof product.addons === "string"
                                  ? JSON.parse(product.addons)
                                  : product.addons;
                              return Object.entries(addons).map(
                                ([key, value]) => (
                                  <div key={key}>
                                    {key}: {value}
                                  </div>
                                )
                              );
                            } catch (e) {
                              return <div>{product.addons}</div>;
                            }
                          })()}
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        minWidth: "80px",
                        textAlign: "right",
                        fontWeight: 500,
                      }}
                    >
                      {getFormattedPrice(product.price)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div
              style={{
                borderBottom: "1px dashed #000",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ marginBottom: "10px" }}>
              {selectedOrder.discount > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                    color: "green",
                  }}
                >
                  <span>Discount:</span>
                  <span>-{getFormattedPrice(selectedOrder.discount)}</span>
                </div>
              )}
              {selectedOrder.tax_collected > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <span>Tax:</span>
                  <span>{getFormattedPrice(selectedOrder.tax_collected)}</span>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                  marginBottom: "5px",
                }}
              >
                <span>Total:</span>
                <span>{getFormattedPrice(selectedOrder.order_total)}</span>
              </div>
              <div
                style={{
                  borderBottom: "1px dashed #000",
                  marginBottom: "10px",
                }}
              ></div>
              {selectedOrder.split_payment?.payments ? (
                <>
                  {selectedOrder.split_payment.payments.map((payment, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <span>{payment.type}:</span>
                      <span>{getFormattedPrice(payment.amount)}</span>
                    </div>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    <span>Tendered Amount:</span>
                    <span>
                      {getFormattedPrice(selectedOrder.amount_paid)}
                    </span>
                  </div>
                  {parseFloat(selectedOrder.change_given || 0) > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <span>Change Given:</span>
                      <span>
                        {getFormattedPrice(selectedOrder.change_given)}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "5px",
                    }}
                  >
                    <span>Tendered Amount:</span>
                    <span>{getFormattedPrice(selectedOrder.amount_paid)}</span>
                  </div>
                  {parseFloat(selectedOrder.change_given || 0) > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <span>Change Given:</span>
                      <span>
                        {getFormattedPrice(selectedOrder.change_given)}
                      </span>
                    </div>
                  )}
                </>
              )}
              {selectedOrder?.refund_amount > 0 && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "5px",
                      color: "red",
                    }}
                  >
                    <span>Refund Amount:</span>
                    <span>
                      -{getFormattedPrice(selectedOrder.refund_amount)}
                    </span>
                  </div>
                  <div
                    style={{
                      borderBottom: "1px dashed #000",
                      marginBottom: "10px",
                    }}
                  ></div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: "bold",
                      marginBottom: "5px",
                    }}
                  >
                    <span>Net Amount:</span>
                    <span>
                      {getFormattedPrice(
                        selectedOrder.order_total - selectedOrder.refund_amount
                      )}
                    </span>
                  </div>
                </>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "5px",
                }}
              >
                <span>Balance Due</span>
                <span>
                  {(() => {
                    const refundAmount = parseFloat(
                      selectedOrder.refund_amount || 0
                    );
                    const netAmount =
                      parseFloat(selectedOrder.order_total) - refundAmount;
                    const balance =
                      netAmount - parseFloat(selectedOrder.amount_paid);
                    return balance > 0 ? getFormattedPrice(balance) : "$0.00";
                  })()}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <Barcode
                displayValue={false}
                height={50}
                value={`tealbo`}
                style={{ fill: "transparent" }}
              />
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            onPrintReceipt(selectedOrder);
            toggle();
          }}
        >
          <FaPrint className="me-1" /> Print Receipt
        </Button>
        <Button
          color="info"
          onClick={() => {
            onPrintLabel(selectedOrder);
            toggle();
          }}
        >
          <FaTag className="me-1" /> Print Label
        </Button>
        <Button color="warning" onClick={handleRefund}>
          <FaDollarSign className="me-1" /> Refund
        </Button>
        <Button
          color="danger"
          onClick={() => {
            onDelete(selectedOrder);
            toggle();
          }}
        >
          <FaTrash className="me-1" /> Delete
        </Button>
      </ModalFooter>

      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .modal-body, .modal-body * {
              visibility: visible;
            }
            .modal {
              position: absolute;
              left: 0;
              top: 0;
              margin: 0;
              padding: 0;
              min-height: 550px;
              width: 100%;
            }
            .modal-dialog {
              margin: 0;
              padding: 0;
              max-width: none;
              width: 100%;
            }
            .modal-content {
              border: none;
              box-shadow: none;
              margin: 0;
              padding: 0;
            }
            .modal-header, .modal-footer {
              display: none;
            }
            .modal-body {
              padding: 0;
              margin: 0;
            }
          }
        `}
      </style>
    </Modal>
  );
};

export default InvoiceModal;
